import { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import { AppContext } from '../../context';

const Navigator = ({ location, history }) => {
  const { navigateTo, untrackedNavigateTo, setContext } = useContext(
    AppContext
  );
  useEffect(() => {
    if (navigateTo && location.pathname !== navigateTo) {
      setContext({ navigateTo: null });
      history.push(navigateTo);
    } else if (
      untrackedNavigateTo &&
      location.pathname !== untrackedNavigateTo
    ) {
      setContext({ untrackedNavigateTo: null });
      history.replace(untrackedNavigateTo);
    }
  }, [history, location.pathname, navigateTo, setContext, untrackedNavigateTo]);

  return null;
};

export default withRouter(Navigator);
